import React, { Component } from "react"

export default class ErrorBoundary extends Component {
	state = {
		hasError: false
	}

	static getDerivedStateFromError(error) {
		this.setState({ hasError: true })
	}

	render() {
		if (this.state.hasError) {
			return (
				<main className='main main--lazy'>
					<h1 className='heading--1'>
						An error occured!! Please reload the page.
					</h1>
				</main>
			)
		}

		return this.props.children
	}
}
